import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { ColorFunction } from '@styles/colors/types';
import { ContainerStyle } from '@interfaces/base';

interface SeparatorProps extends ContainerStyle {
  C: ColorFunction;
}

const Separator: FC<SeparatorProps> = ({ C, containerStyle }) => {
  return <View style={[{ borderBottomColor: C('Hairline/Light/No trans'), borderBottomWidth: StyleSheet.hairlineWidth, width: '100%' }, containerStyle]} />;
};

export default Separator;
